import type { Resource } from '../../';
export const forms_field_shippingSelection: Resource = {"default":"Select Shipping Method:"};
